import { ItensOrcamentoContainer } from "app/components/itens-orcamento/ItensOrcamentoContainer"
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact"
import { useAppSelector } from "app/redux/hooks"
import { ControllerLegado } from "app/types/ControllerLegado"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { definirPrecoTintaItem } from "app/use-cases/orcamento/definirPrecoTintaItem"
import React from "react"
import { EditarItemContainer } from "../EditarItemContainer"
import { EditarPrecoTinta, EditarPrecoTintaProps } from "./EditarPrecoTinta"
import globalMU from "globalMU"
import { TelaEdicaoItensContainer } from "../TelaEdicaoItensContainer"
import { tratamentoErroPadrao } from "app/use-cases"

export type EditarPrecoTintaContainerProps = {
    item: IItemOrcamento
    itemOrcamentoController:ControllerLegado
}

export const EditarPrecoTintaContainer = (props: EditarPrecoTintaContainerProps) => {

    const orcamento = useAppSelector(store => store.orcamento)

    const obterCorantes = () : EditarPrecoTintaProps["DadosEntrada"]["DadosCorantes"] => {

        return (orcamento.ItensOrcamento ?? []).filter(i => i.CodigoTinta == props.item.CodigoTinta).map(i => ({
            Codigo: i.CodigoProduto,
            Nome: i.DescricaoProduto,
            Quantidade: i.Quantidade
        } as EditarPrecoTintaProps["DadosEntrada"]["DadosCorantes"][0]))
    }

    const alterarPreco = async (preco: number) => {
        try {
            globalMU.blockUI();
            await definirPrecoTintaItem({ identificadorItem: props.item.Identificador, preco: preco })
            renderizarComponentReact(
                <TelaEdicaoItensContainer
                    identificadoresItensSelecionados={orcamento.ItensOrcamento.map(i => i.Identificador)}
                    itemOrcamentoController={props.itemOrcamentoController}
                />,
                "conteudo-pagina",
                true
            )
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    return <>
        <EditarPrecoTinta
            DadosEntrada={{
                PrecoUnitario: props.item.PrecoTinta,
                Produto: props.item.DescricaoProduto,
                Cor: props.item.DescricaoCorTinta,
                DadosCorantes: obterCorantes()
            }}
            onPrecoAlterado={alterarPreco}/>
    </>
}